//Please add the language resource
const systemLog = {
  userNo: 'userNo',
  userName: 'userName',
  ipAddress: 'ipAddress',
  title: 'title',
  businessType: 'businessType',
  method: 'method',
  requestMethod: 'requestMethod',
  requestUrl: 'requestUrl',
  responseTime: 'responseTime',
  requestParam: 'requestParam',
  responseResult: 'responseResult',
  operateStatus: 'operateStatus',
  errorMsg: 'errorMsg',
  createTime: 'createTime',
  msg: {}
};
export default systemLog



// WEBPACK FOOTER //
// ./src/page/log/systemLog/lang/systemLog.en.js